// src/components/LanguageRoute.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LanguageRoute = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Extract language from URL path
    const pathSegments = location.pathname.split("/");
    const langFromUrl = pathSegments[1];
    const targetLanguage =
      langFromUrl === "en" || langFromUrl === "de" ? langFromUrl : "de";

    document.documentElement.lang = targetLanguage;

    // Check if the first segment is a valid language code
    if (langFromUrl === "en" || langFromUrl === "de") {
      // Change language if it's different from current
      if (i18n.language !== targetLanguage) {
        i18n.changeLanguage(targetLanguage);
      }
    } else {
      // Default to German for root paths or invalid language codes
      if (i18n.language !== "de") {
        i18n.changeLanguage("de");
      }
    }
  }, [location.pathname, i18n]);

  return children;
};

export default LanguageRoute;
